import React, { Component } from 'react'
import Header from "./Header";
import Footer from "./Footer";
import { Multiselect } from "multiselect-react-dropdown";
export class Partner extends Component {
    constructor(props) {
        super(props);
        this.state = {
          dropdown_insurance: [
            { name: "Health Insurance", id: 1 },
            { name: "Life Insurance", id: 2 },
            { name: "General Insurance", id: 3 },
          ],
          dropdown_domestic_real_estate_india: [
            { name: "Mumbai", id: 1 },
            { name: "Delhi NCR", id: 2 },
            { name: "Kolkata", id: 3 },
            { name: "Chennai", id: 4 },
            { name: "Bangalore", id: 5 },
            { name: "Hyderabad", id: 6 },
            { name: "Ahmedabad", id: 7 },
            { name: "Pune", id: 8 },
            { name: "Jaipur", id: 9 },
            { name: "Chandigarh", id: 10 },
            { name: "Ludhiana", id: 11 },
            { name: "Kanpur", id: 12 },
            { name: "Lucknow", id: 13 },
            { name: "Goa", id: 14 },
          ],
    
          dropdown_mutual_funds: [
            { name: "Domestic Mutual Funds", id: 1 },
            { name: "International Mutual Funds", id: 2 },
          ],
          dropdown_functional_real_estate: [
            { name: "Commercial Real Estate", id: 1 },
            { name: "Warehouses", id: 2 },
            { name: "Holiday Homes", id: 3 },
          ],
          dropdown_international_listed_equities: [
            { name: "US Listed Stocks", id: 1 },
            { name: "US Exchange Traded Funds", id: 2 },
          ],
          dropdown_loans: [
            { name: "Home Loans", id: 1 },
            { name: "Loan Against Property", id: 2 },
            { name: "Personal Loans", id: 3 },
            { name: "Business Loans", id: 4 },
            { name: "Vehicle Loans", id: 5 },
          ],
          dropdown_real_estate_funds: [
            { name: "US Real Estate Funds", id: 1 },
            { name: "UK Real Estate Funds", id: 2 },
            { name: "Indian Real Estate Funds", id: 3 },
          ],
          dropdown_taxationandcompliance: [
            { name: "Tax Filing", id: 1 },
            { name: "Foreign Income Tax Filing", id: 2 },
            { name: "Account Services", id: 3 },
            { name: "GST Services", id: 4 },
            { name: "Company Formation", id: 5 },
          ],
    
          dropdown_international_real_estate: [
            { cat: "United Arab Emirates", name: "United Arab Emirates", id: 1 },
            { cat: "United Kingdom", name: "United Kingdom", id: 2 },
            { cat: "Europe", name: "Europe", id: 3 },
            { cat: "Greece", name: "Greece", id: 4 },
            { cat: "Cyprus", name: "Cyprus", id: 5 },
            {
              cat: "United States of America",
              name: "United States of America",
              id: 6,
            },
            { cat: "Canada", name: "Canada", id: 7 },
            { cat: "Thailand", name: "Thailand", id: 8 },
          ],
    
          dropdown_prandcitizenship_by_investment: [
            { name: "USA (EB-5)", id: 1 },
            { name: "Canada", id: 2 },
            { name: "United Kingdom", id: 3 },
            { name: "Portugal", id: 4 },
            { name: "Ireland", id: 5 },
            { name: "Turkey", id: 6 },
            { name: "Malta", id: 7 },
            { name: "Bulgaria", id: 8 },
            { name: "Qatar", id: 9 },
            { name: "Brazil", id: 10 },
            { name: "Bulgaria", id: 11 },
            { name: "Dominica", id: 12 },
            { name: "Grenada", id: 13 },
            { name: "Antigua and Barbuda", id: 14 },
            { name: "St Lucia", id: 15 },
            { name: "St Kittis and Nevis", id: 16 },
            { name: "Vanuatu", id: 17 },
            { name: "Malaysia", id: 18 },
          ],
    
          dropdown_technical_support: [
            { name: "B2B Marketing-Global Distribution Platform", id: 1 },
            { name: "B2C Marketing - Reach Client Globally", id: 2 },
            { name: "Digital Advertising Campaign", id: 3 },
            { name: "SMO and SEO", id: 4 },
            { name: "PPC Campaign Management", id: 5 },
            { name: "Lead Generation", id: 6 },
          ],
        };
      }
      onSelect(selectedList, selectedItem) {}
    
      onRemove(selectedList, removedItem) {}
      render() {
        return (
          <div>
            <Header />
            <section id="contact">
              <div class="container-fluid" data-aos="fade-up">
                <br />
                <br />
    
                <div class="section-header">
                  <h3>Join Our Growing Network Of Partner</h3>
                </div>
    
                <div class="section-header">
                  <h4>
                    Don't miss the unique oppurtunity of becoming a leading partner in your region.
                  </h4>
                </div>
    
                <div class="section-header">
                  <h4>Choose from our Product Offering</h4>
                  <p>(Select At Least One*)</p>
                </div>
    
                <div className="container">
                  <form onSubmit={this.onSubmit}>
                    <div class="row">
                      <div className="col-sm-4">
                        <input
                          type="text"
                          className="form-control form-control-md"
                          placeholder="Enter name"
                          name="name"
                          onChange={this.onChange}
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_insurance} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Insurance"
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_domestic_real_estate_india} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Domestic Real Estate India"
                        />
                      </div>
                    </div>
                    <br />
    
                    <div class="row">
                      <div className="col-sm-4">
                        <input
                          type="text"
                          className="form-control form-control-md"
                          placeholder="Enter name"
                          name="name"
                          onChange={this.onChange}
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_mutual_funds} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Mutual Funds"
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_functional_real_estate} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Fractional Real Estate"
                        />
                      </div>
                    </div>
    
                    <br />
    
                    <div class="row">
                      <div className="col-sm-4">
                        <Multiselect
                          options={
                            this.state.dropdown_international_listed_equities
                          } // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="International Listed Equities"
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_loans} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Loans"
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={
                            this.state
                              .dropdowdropdown_real_estate_fundsn_functional_real_estate
                          } // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Real Estate Funds"
                        />
                      </div>
                    </div>
    
                    <br />
    
                    <div class="row">
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_taxationandcompliance} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Taxation and Compliance"
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_international_real_estate} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          groupBy="cat"
                          placeholder="International Real Estate"
                        />
                      </div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={
                            this.state.dropdown_prandcitizenship_by_investment
                          } // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="PR and Citizenship By Investment"
                        />
                      </div>
                    </div>
    
                    <br />
    
                    <div class="row">
                      <div className="col-sm-4"></div>
    
                      <div className="col-sm-4"></div>
    
                      <div className="col-sm-4">
                        <Multiselect
                          options={this.state.dropdown_technical_support} // Options to display in the dropdown
                          selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                          onSelect={this.onSelect} // Function will trigger on select event
                          onRemove={this.onRemove} // Function will trigger on remove event
                          displayValue="name" // Property name to display in the dropdown options
                          showCheckbox={true}
                          placeholder="Technical Support"
                        />
                      </div>
                    </div>
                    <br />
    
                    <div class="section-header">
                      <h4>
                        Please share your details. Our team will get back to you on
                        priority.
                      </h4>
                    </div>
                    <br />
    
                    <div class="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-md"
                          placeholder="Full name"
                          name="name"
                          onChange={this.onChange}
                        />
                      </div>
    
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-md"
                          placeholder="E-mail Address"
                          name="name"
                          onChange={this.onChange}
                        />
                      </div>
                    </div>
                    <br />
    
                    <div class="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-md"
                          placeholder="Mobile No"
                          name="name"
                          onChange={this.onChange}
                        />
                      </div>
    
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-md"
                          placeholder="Location"
                          name="name"
                          onChange={this.onChange}
                        />
                      </div>
                    </div>
                    <br />
    
                    <div class="row">
                      <div className="col-sm-6"></div>
    
                      <div className="col-sm-6">
                        <button
                          variant="primary"
                          type="submit"
                          class="col-sm-6 btn btn-info"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                    <br />
                    <div class="section-header">
                      <h4>
                        Whether you're new to investing or seasoned pro, it's time
                        to partner with company that believes you could- and should
                        be - getting more from your money.
                      </h4>
                    </div>
                  </form>
                </div>
              </div>
            </section>
            <Footer />
          </div>
        )
    }
}

export default Partner
